import SettlementRunDetail from "../js/components/settlements/SettlementRunDetail.react";
export default SettlementRunDetail;
